import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CrudService } from "../crud.service";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class SpecialitesService extends CrudService {
    constructor(httpClient: HttpClient) {
        super(httpClient, "specialties");
    }
    getMedicalSpecialization() {
        const t = this;
        return this.httpClient
            .get(t.endpoint + "/CFP")
            .pipe(map((res: any) => res || []));
    }
}
